// 路由配置文件，负责管理前端页面的导航和组件加载
// 在 Vue 项目架构中属于“路由层”，决定页面跳转和视图切换
// 通过不同的 URL 路径，动态加载不同的页面组件

// 1. 引入 vue-router 的核心方法 createRouter、createWebHistory
import { createRouter, createWebHistory } from 'vue-router'

// 2. 引入各个页面组件（视图），这些组件会根据路由动态加载
import MainDashboard from '../views/MainDashboard.vue' // 首页主面板
import PeopleScreen from '../views/PeopleScreen.vue' // 人员管理页面
import LocationScreen from '../views/LocationScreen.vue' // 地理位置页面
import EventScreen from '../views/EventScreen.vue' // 事件处理页面
import DeviceScreen from '../views/DeviceScreen.vue' // 设备管理页面
import CommunityOverview from '../views/CommunityOverview.vue' // 社区总览页面
import WisdomCommunityScreen from '../views/WisdomCommunityScreen.vue' // 智慧社区页面
import CommunityRecruitmentDashboard from '../views/CommunityRecruitmentDashboard.vue' // 社区招聘页面

// 3. 定义路由表 routes，每个对象就是一个页面的路由配置
//    path: 路径，name: 路由名称，component: 该路径下渲染的组件
const routes = [
  {
    path: '/', // 根路径，对应首页
    name: 'MainDashboard', // 路由名称
    component: MainDashboard // 显示的组件
  },
  {
    path: '/people', // 人员页面
    name: 'PeopleScreen',
    component: PeopleScreen
  },
  {
    path: '/location', // 地点页面
    name: 'LocationScreen',
    component: LocationScreen
  },
  {
    path: '/event', // 事件页面
    name: 'EventScreen',
    component: EventScreen
  },
  {
    path: '/device', // 设备页面
    name: 'DeviceScreen',
    component: DeviceScreen
  },
  {
    path: '/community-overview', // 社区总览
    name: 'CommunityOverview',
    component: CommunityOverview
  },
  {
    path: '/wisdom-community', // 智慧社区
    name: 'WisdomCommunityScreen',
    component: WisdomCommunityScreen
  },
  {
    path: '/community-recruitment', // 社区招募
    name: 'CommunityRecruitmentDashboard',
    component: CommunityRecruitmentDashboard
  }
]

// 4. 创建路由实例 router，配置为 history 模式（无 # 号，URL 更美观）
//    history: 路由模式，routes: 路由表
const router = createRouter({
  history: createWebHistory(), // 使用 HTML5 history 模式
  routes // 路由表
})

// 5. 导出路由实例，供 main.js 注册到 Vue 应用中
export default router